<hr />
<div class="gv-item" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap.lt-md="8px">
  <div *ngIf="label" class="text-sm" fxFlex="220px" fxFlex.lt-md="none">{{ label }}</div>
  <div fxFlex class="gv-item-value">
    {{ value }}
  </div>
  <ui-icon
    icon="griddy-copy"
    [size]="20"
    matTooltip="Copy to clipboard"
    ngxClipboard
    [cbContent]="value"
    class="p-2"></ui-icon>
</div>
